import { formatPhone, formatCPF } from '@bit/wavfichacerta.fichacerta.utils.formatters';

export const getInitialValues = (state) => {
  const { employerForm: { userData } } = state;
  if (typeof userData.data === "object" && Object.keys(userData.data).length > 0) {
    const { data } = userData;
    let accessType = [];
    if (data.funcionario.operacional) {
      accessType.push("operacional");
    }

    if (data.funcionario.financeiro) {
      accessType.push("financeiro");
    }

    return {
      tipo_usuario: data.funcionario.master? "MASTER" : "ADICIONAL",
      nome: data.pessoa.nome,
      cpf: formatCPF(data.pessoa.cpf),
      identidade: data.pessoa.identidade,
      orgao_expedidor: data.pessoa.orgao_expedidor,
      funcao: data.funcionario.funcao,
      email: data.usuario.email,
      tipo_acesso: data.usuario.tipo_acesso || 'LOGIN_SENHA',
      acesso_lucia: data.funcionario.acesso_lucia ? "1" : "0",
      alcada_lucia: data.funcionario.alcada_lucia || "",
      alcada_lucia_coleta: data.funcionario.alcada_lucia_coleta || "",
      lucia_solicita_disponivel: state.login?.user?.usuario?.lucia_solicita_disponivel === true,
      lucia_coleta_disponivel: state.login?.user?.usuario?.lucia_coleta_disponivel === true,
      telefone: formatPhone(data.telefones?.principal?.numero),
      whatsapp: formatPhone(data.telefones?.whatsapp?.numero),
      whatsapp_confirmation: formatPhone(data.telefones?.whatsapp?.numero),
      restrito: data.telefones?.whatsapp?.restrito ? "1" : "0",
      credit: `R$ ${data.funcionario.credito},00`,
      total: `R$ ${data.funcionario.credito},00`
    }
  }
  return {};
}
